import { render, staticRenderFns } from "./SignalIndicatorMACD.vue?vue&type=template&id=390fd5c3&scoped=true&"
import script from "./SignalIndicatorMACD.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalIndicatorMACD.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390fd5c3",
  null
  
)

export default component.exports